export const timelineEras = [
  {
    id: "era-60s",
    era: "20世纪60—70年代",
    title: "片厂时代的银幕初现",
    text:
      "片厂制度下的古装片把《水浒传》《金瓶梅》段落改编为完整故事，武打线与市井线并行，潘金莲作为支线人物开始被反复演绎。",
    tag: "古装片",
  },
  {
    id: "era-80s",
    era: "1980年代",
    title: "文艺化的重新书写",
    text:
      "这一时期出现以现代视角重读古典人物的改编，注重人物心理与命运，代表方向是把潘金莲放进轮回或都市框架中重新讲述。",
    tag: "文艺改编",
  },
  {
    id: "era-90s",
    era: "1990年代",
    title: "系列化与类型化",
    text:
      "商业系列影片集中出现，片名相近、续集频出，题材被处理得更突出娱乐属性，也成为后来提及最多的一个改编阶段。",
    tag: "系列影片",
  },
  {
    id: "era-98",
    era: "1990年代末",
    title: "长篇电视剧的展开",
    text:
      "名著改编剧以长篇形式容纳群像故事，潘金莲一角获得了更长的篇幅与更完整的人物关系，成为大众最熟悉的影视形象之一。",
    tag: "电视剧",
  },
  {
    id: "era-2010s",
    era: "2010年代",
    title: "重拍与讨论热潮",
    text:
      "重拍版本不断推出，人物选角与情感动机成为讨论重点，也让这一题材在网络上持续获得新的关注与检索需求。",
    tag: "重拍版",
  },
  {
    id: "era-now",
    era: "近年",
    title: "网络影像与短剧",
    text:
      "网络电影与竖屏短剧借用人物名号进行轻量改编，篇幅更短、节奏更快，构成当代衍生的一种新形态。",
    tag: "网络影像",
  },
];